// extracted by mini-css-extract-plugin
export default {"card":"BReportCard-module_card_a84ab217","button":"BReportCard-module_button_c10f65b8"};